import type { ReactNode } from 'react';
import { Button } from '@elka/ui';

export interface PageHeaderAction {
  label: string;
  onClick: () => void;
  icon?: ReactNode;
}

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  action?: PageHeaderAction;
}

/**
 * Page header with gradient title and optional action button.
 * On mobile the button stacks below the title at full width;
 * on desktop it sits inline to the left (RTL) / right (LTR).
 */
export function PageHeader({ title, subtitle, action }: PageHeaderProps) {
  return (
    <div className="animate-fadeInFast mb-6 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div>
        <h1 className="gradient-text mb-1 text-3xl font-extrabold tracking-tight text-balance sm:text-4xl">
          {title}
        </h1>
        {subtitle && <p className="text-sm font-medium text-gray-500">{subtitle}</p>}
      </div>
      {action && (
        <Button
          onClick={action.onClick}
          variant="gradient"
          responsive
          className="flex items-center justify-center gap-2 shadow-lg"
        >
          {action.icon}
          {action.label}
        </Button>
      )}
    </div>
  );
}
